<template>
  <base-wrapper
    :loading="
      loadingPatterns ||
      loadingSavePattern ||
      loadingHandlers ||
      loadingDelete ||
      loadingCheckPattern
    "
  >
    <div class="space-y-4">
      <div class="flex justify-end gap-2">
        <base-input
          type="text"
          placeholder="Cari pattern"
          :shadow="false"
          v-model="filter.search"
          debounce
          @native-input="loadPatterns"
        />
        <base-button @click="onOpenCreateFormModal">
          <Icon icon="heroicons:plus" class="h-4 w-4" />
          Tambah Pola
        </base-button>
      </div>
      <datatable
        :columns="[
          { id: 'pattern', name: 'Pola' },
          { id: 'media_mime_type', name: 'Tipe Media' },
          { id: 'media_size', name: 'Ukuran Media' },
          { id: 'action', name: 'Action', theadClass: 'text-center' },
        ]"
        :total="patterns.meta.page.total"
        :perPage="patterns.meta.page.perPage"
        :currentPage="patterns.meta.page.currentPage"
        @pagechanged="onChangePage"
      >
        <template #tbody="{ classes }">
          <tr
            v-for="pattern in patterns.data"
            :key="pattern.id"
            :class="[classes.tr, 'bg-white hover:bg-green-100']"
          >
            <td
              :class="[classes.td, 'cursor-pointer']"
              @click="onOpenDetailModal(pattern)"
            >
              {{ pattern.attributes.pattern }}
            </td>
            <td
              :class="[classes.td, 'cursor-pointer']"
              :title="pattern.attributes.media_mime_type"
              @click="onOpenDetailModal(pattern)"
            >
              <Icon
                v-if="pattern.attributes.media_mime_type"
                :icon="getMimeTypeIcon(pattern.attributes.media_mime_type)"
                :class="[
                  'h-5 w-5',
                  getMimeTypeColor(pattern.attributes.media_mime_type),
                ]"
              />
              <span v-else>-</span>
            </td>
            <td
              :class="[classes.td, 'cursor-pointer']"
              @click="onOpenDetailModal(pattern)"
            >
              <span v-if="!pattern.attributes.media_size">-</span>
              <span v-else>
                {{ pattern.attributes.media_size | formatBytes }}
              </span>
            </td>
            <td :class="[classes.td]">
              <div class="flex items-center justify-center gap-1">
                <base-button size="sm" @click="onOpenEditFormModal(pattern)">
                  <Icon icon="heroicons:pencil-square-solid" class="h-4 w-4" />
                </base-button>
                <base-button
                  size="sm"
                  color="danger"
                  @click="onOpenDeleteModal(pattern)"
                >
                  <Icon icon="heroicons:trash-solid" class="h-4 w-4" />
                </base-button>
              </div>
            </td>
          </tr>
        </template>
      </datatable>
    </div>

    <base-modal
      :showing="formModal.visible"
      @close="formModal.visible = false"
      size="max-w-5xl"
    >
      <base-card
        :with-style="false"
        :title="`${formModal.id ? 'Edit' : 'Tambah'} Pola`"
        :description="`${
          formModal.id ? 'Edit' : 'Tambah'
        } whatsapp pola respon baru`"
      >
        <form class="space-y-4 border-t pt-5" @submit.prevent="onSaveForm">
          <base-toggle
            with-label
            label-true="Dengan Parameter"
            label-false="Tanpa Parameter"
            v-model="formModal.form.withParams"
          />
          <base-input
            type="text"
            label="Pola"
            placeholder="Contoh: PRODUK"
            inset
            v-model="formModal.form.pattern"
            @change="onChangePattern"
          />
          <template v-if="formModal.form.withParams">
            <base-input label="Fungsi Pola" inset>
              <base-select
                inset
                expand
                :options="handlerOptions"
                v-model="formModal.form.handler"
                @change="onChangeHandler"
              />
            </base-input>

            <template v-if="formModal.form.handler">
              <div class="grid grid-cols-2">
                <base-input label="Pilih Parameter">
                  <base-checkbox
                    v-for="param in selectedHandlerParamOptions"
                    :key="param.id"
                    with-label
                    :label="`${param.id} (${param.name})`"
                    :name="`param-${param.id}`"
                    :input-value="param.id"
                    :disabled="param.required || !!param.visible_by_params"
                    v-model="formModal.form.params"
                    @change="(checked) => onChangeParam(checked, param)"
                  />
                </base-input>
                <base-input label="Pilih Output">
                  <base-checkbox
                    v-for="output in selectedHandlerOutputOptions"
                    :key="output.id"
                    with-label
                    :label="`${output.id} (${output.name})${
                      output.multiple ? `, tipe array (0-${output.max})` : ''
                    }`"
                    :name="`output-${output.id}`"
                    :input-value="output.id"
                    v-model="formModal.form.outputs"
                  />
                </base-input>
              </div>

              <base-input
                type="text"
                label="Hasil Parameter"
                disabled
                inset
                :value="
                  formModal.form.params.map((param) => `<<${param}>>`).join(' ')
                "
              />

              <div
                v-if="formModal.form.params.length"
                class="grid grid-cols-2 gap-4"
              >
                <div class="space-y-1">
                  <base-input
                    tag="textarea"
                    rows="10"
                    label="Respon Balasan Berhasil"
                    placeholder="Contoh: Produk <<pattern>> memiliki harga ..."
                    inset
                    v-model="formModal.form.successResponse"
                  />
                  <p class="text-xs text-gray-500">
                    Gunakan &lt;&lt;pattern&gt;&gt; untuk mereferensikan ke nama
                    pattern<br />
                    Gunakan &lt;&lt;param.nama parameter&gt;&gt; untuk
                    mereferensikan ke parameter<br />
                    Gunakan &lt;&lt;output.nama output&gt;&gt; untuk
                    mereferensikan ke output<br />
                    Gunakan &lt;&lt;output.nama output.index&gt;&gt; untuk
                    mereferensikan ke output yang bertipe array (dari 0)
                  </p>
                </div>
                <div class="space-y-1">
                  <base-input
                    tag="textarea"
                    rows="10"
                    label="Respon Balasan Gagal"
                    placeholder="Contoh: Produk <<pattern>> tidak ditemukan ..."
                    inset
                    v-model="formModal.form.failedResponse"
                  />
                  <p class="text-xs text-gray-500">
                    Gunakan &lt;&lt;pattern&gt;&gt; untuk mereferensikan ke nama
                    pattern<br />
                    Gunakan &lt;&lt;param.nama parameter&gt;&gt; untuk
                    mereferensikan ke parameter<br />
                    Gunakan &lt;&lt;error&gt;&gt; untuk mereferensikan ke pesan
                    error
                  </p>
                </div>
              </div>
            </template>
          </template>
          <div v-else class="space-y-1">
            <base-input
              tag="textarea"
              rows="10"
              label="Respon Balasan"
              placeholder="Contoh: Produk <<pattern>> memiliki harga ..."
              inset
              v-model="formModal.form.defaultResponse"
            />
            <p class="text-xs text-gray-500">
              Ganti &lt;&lt;pattern&gt;&gt; untuk mereferensikan ke nama pattern
            </p>
          </div>

          <template v-if="!formModal.form.withParams || formModal.form.handler">
            <div
              class="space-y-1"
              v-if="
                !formModal.id ||
                !formModal.form.mediaUrl ||
                formModal.form.editMedia
              "
            >
              <base-input
                inset
                :label="
                  formModal.id ? `Media (Kosongkan jika tidak diubah)` : 'Media'
                "
                type="file"
                accept=".pdf,.jpg,.png,.mp4"
                @change="onChangeMedia"
              />
              <p class="text-xs text-gray-500">
                Jenis file yang didukung: pdf, jpg, png, mp4<br />
                Maks ukuran file: 16MB
              </p>
            </div>
            <div v-else>
              <p class="mb-1 flex items-center gap-2 text-sm font-medium">
                Media
                <button
                  type="button"
                  class="text-sm font-medium leading-6 text-green-600"
                  @click="formModal.form.editMedia = true"
                >
                  Edit
                </button>
              </p>
              <a
                :href="formModal.form.mediaUrl"
                target="_blank"
                class="text-sm font-medium leading-6 text-green-600"
              >
                Preview Media
              </a>
            </div>
          </template>

          <div class="flex gap-2">
            <base-button :disabled="!formModalValidSubmit">Simpan</base-button>
            <base-button
              type="button"
              color="white"
              @click="formModal.visible = false"
              >Batal</base-button
            >
          </div>
        </form>
      </base-card>
    </base-modal>

    <base-modal
      :showing="detailTemplate.visible"
      @close="detailTemplate.visible = false"
    >
      <base-card :with-style="false" title="Detail Pola">
        <div class="space-y-4">
          <div>
            <p class="mb-1 text-sm font-medium">Pola</p>
            <p class="text-sm leading-6 text-gray-700">
              {{ detailTemplate.pattern }}
            </p>
          </div>
          <div>
            <p class="mb-1 text-sm font-medium">Dengan Media</p>
            <p class="text-sm leading-6 text-gray-700">
              {{ detailTemplate.hasMedia ? 'Ya' : 'Tidak' }}
            </p>
          </div>
          <template v-if="detailTemplate.hasMedia">
            <div>
              <p class="mb-1 text-sm font-medium">Tipe Media</p>
              <p
                class="text-sm leading-6 text-gray-700"
                :title="detailTemplate.mediaMimeType"
              >
                <Icon
                  v-if="detailTemplate.mediaMimeType"
                  :icon="getMimeTypeIcon(detailTemplate.mediaMimeType)"
                  :class="[
                    'h-5 w-5',
                    getMimeTypeColor(detailTemplate.mediaMimeType),
                  ]"
                />
                <span v-else>-</span>
              </p>
            </div>
            <div>
              <p class="mb-1 text-sm font-medium">Ukuran Media</p>
              <p class="text-sm leading-6 text-gray-700">
                {{ detailTemplate.mediaSize | formatBytes }}
              </p>
            </div>
            <div>
              <p class="mb-1 text-sm font-medium">Link Media</p>
              <a
                :href="detailTemplate.mediaUrl"
                target="_blank"
                class="text-sm font-medium leading-6 text-green-600"
              >
                Preview
              </a>
            </div>
          </template>
          <template v-if="detailTemplate.handler">
            <div>
              <p class="mb-1 text-sm font-medium">Fungsi</p>
              <p class="text-sm leading-6 text-gray-700">
                {{
                  detailTemplate.handler
                    ? getDetailHandler(detailTemplate.handler).name
                    : '-'
                }}
              </p>
            </div>
            <div>
              <p class="mb-1 text-sm font-medium">Parameter</p>
              <p class="text-sm leading-6 text-gray-700">
                {{ detailTemplate.params ?? '-' }}
              </p>
            </div>
            <div>
              <p class="mb-1 text-sm font-medium">Output</p>
              <p class="text-sm leading-6 text-gray-700">
                {{ detailTemplate.outputs ?? '-' }}
              </p>
            </div>
            <div>
              <p class="mb-1 text-sm font-medium">Respon Balasan Berhasil</p>
              <p class="text-sm leading-6 text-gray-700">
                {{ detailTemplate.successResponse ?? '-' }}
              </p>
            </div>
            <div>
              <p class="mb-1 text-sm font-medium">Respon Balasan Gagal</p>
              <p class="text-sm leading-6 text-gray-700">
                {{ detailTemplate.failedResponse ?? '-' }}
              </p>
            </div>
          </template>
          <div v-else>
            <p class="mb-1 text-sm font-medium">Respon Balasan</p>
            <p class="text-sm leading-6 text-gray-700">
              {{ detailTemplate.defaultResponse ?? '-' }}
            </p>
          </div>
        </div>
      </base-card>
    </base-modal>

    <base-confirm
      :visible="deleteModal.visible"
      icon-type="badge"
      title="Hapus Pola"
      message="Pola yang dihapus tidak dapat dikembalikan lagi, konfirmasi hapus?"
      @close="deleteModal.visible = false"
      @confirmed="onDeleteConfirmed"
    />
  </base-wrapper>
</template>

<script>
import { requestMixin } from '../../../mixins/request/request';
import BaseModal from '../../../components/base/BaseModal.vue';
import BaseConfirm from '../../../components/base/BaseConfirm.vue';
import BaseToggle from '../../../components/base/BaseToggle.vue';
import BaseCheckbox from '../../../components/base/BaseCheckbox.vue';
import { mapActions } from 'vuex';

export default {
  mixins: [requestMixin],
  components: {
    BaseModal,
    BaseConfirm,
    BaseToggle,
    BaseCheckbox,
  },
  data() {
    return {
      filter: {
        search: null,
      },
      formModal: {
        visible: false,
        id: null,
        form: {
          pattern: null,
          defaultResponse: null,
          successResponse: null,
          failedResponse: null,
          withParams: false,
          handler: null,
          params: [],
          outputs: [],
          media: null,
          mediaUrl: null,
          editMedia: false,
        },
      },
      detailTemplate: {
        visible: false,
        pattern: null,
        params: null,
        outputs: null,
        successResponse: null,
        failedResponse: null,
        handler: null,
        defaultResponse: null,
        hasMedia: false,
        mediaMimeType: null,
        mediaSize: null,
        mediaUrl: null,
      },
      deleteModal: {
        id: null,
        visible: false,
      },
      handlers: [],
      loadingDelete: false,
      loadingHandlers: false,
      loadingPatterns: true,
      loadingSavePattern: false,
      loadingCheckPattern: false,
      patterns: {
        data: [],
        meta: {
          page: {},
        },
      },
    };
  },
  computed: {
    formModalValidSubmit() {
      if (!this.formModal.form.withParams) {
        return (
          this.formModal.form.pattern && this.formModal.form.defaultResponse
        );
      }

      return (
        this.formModal.form.pattern &&
        this.formModal.form.params.length &&
        this.formModal.form.outputs.length &&
        this.formModal.form.successResponse &&
        this.formModal.form.failedResponse
      );
    },
    handlerOptions() {
      return [
        {
          key: 'null',
          label: 'Pilih Fungsi',
          value: null,
        },
        ...this.handlers.map((handler) => ({
          key: handler.id,
          label: `${handler.name} (${handler.description})`,
          value: handler.id,
        })),
      ];
    },
    selectedHandlerParamOptions() {
      if (!this.formModal.form.handler) {
        return [];
      }

      return this.getDetailHandler(this.formModal.form.handler).params.filter(
        (param) => {
          if (!param.visible_by_params) {
            return true;
          }

          return this.formModal.form.params.includes(param.visible_by_params);
        }
      );
    },
    selectedHandlerOutputOptions() {
      if (!this.formModal.form.handler) {
        return [];
      }

      return this.getDetailHandler(this.formModal.form.handler).outputs.filter(
        (output) => {
          if (!output.visible_by_params) {
            return true;
          }

          return this.formModal.form.params.includes(output.visible_by_params);
        }
      );
    },
  },
  methods: {
    ...mapActions({
      createAlert: 'alert/createAlert',
    }),
    getMimeTypeIcon(mime) {
      if (mime.startsWith('image/')) {
        return 'mdi:file-image';
      }

      if (mime.startsWith('video/')) {
        return 'mdi:file-video';
      }

      return 'mdi:file-document';
    },
    getMimeTypeColor(mime) {
      if (mime.startsWith('image/')) {
        return 'text-blue-600';
      }

      if (mime.startsWith('video/')) {
        return 'text-indigo-600';
      }

      return 'text-red-600';
    },
    getDetailHandler(id) {
      return this.handlers.find((handler) => handler.id === id);
    },
    getDetailHandlerOutput(id) {
      return this.getDetailHandler(this.formModal.form.handler).outputs.find(
        (output) => output.id === id
      );
    },
    async loadHandlers() {
      this.loadingHandlers = true;

      const [res, err] = await this.request(
        '/api/v1/whatsapp-response-patterns/-actions/get-handlers'
      );

      if (!err) {
        this.handlers = res;
      }

      this.loadingHandlers = false;
    },
    async loadPatterns(params) {
      this.loadingPatterns = true;

      const [res, err] = await this.request(
        '/api/v1/whatsapp-response-patterns',
        {
          params: {
            'fields[whatsapp-response-patterns]':
              'pattern,handler_class_id,params,outputs,success_response,failed_response,default_response,has_media,media_mime_type,media_size,media_url',
            sort: '-id',
            'page[size]': 5,
            'filter[search]': this.filter.search,
            ...params,
          },
        }
      );

      if (!err) {
        this.patterns = res;
      }

      this.loadingPatterns = false;
    },
    async onChangePattern() {
      this.loadingCheckPattern = true;

      const [, err] = await this.request(
        '/api/v1/whatsapp-response-patterns/-actions/check-pattern-exists',
        {
          params: {
            pattern: this.formModal.form.pattern,
            pattern_id: this.formModal.id,
            has_params: this.formModal.form.withParams,
          },
        }
      );

      if (err) {
        this.createAlert({
          status: 'error',
          data: this.getRequestErrorMessage(err),
        });
      }

      this.loadingCheckPattern = false;
    },
    onChangeParam(checked, param) {
      if (param.required_params.length) {
        if (checked) {
          this.formModal.form.params = [
            ...this.formModal.form.params,
            ...param.required_params,
          ];
        } else {
          this.formModal.form.params = this.formModal.form.params.filter(
            (selectedParam) => !param.required_params.includes(selectedParam)
          );
          this.formModal.form.outputs = this.formModal.form.outputs.filter(
            (selectedOutput) =>
              !this.getDetailHandlerOutput(
                selectedOutput
              ).required_params.includes(param.id)
          );
        }
      }
    },
    onChangeHandler() {
      if (!this.formModal.form.handler) {
        this.formModal.form.params = [];
      } else {
        this.formModal.form.params = this.getDetailHandler(
          this.formModal.form.handler
        )
          .params.filter((param) => param.required)
          .map((param) => param.id);
      }
    },
    onChangeMedia(e) {
      this.formModal.form.media = e.target.files[0];
    },
    onChangePage(page) {
      this.loadPatterns({
        'page[number]': page,
      });
    },
    async onDeleteConfirmed() {
      this.loadingDelete = true;

      const [, err] = await this.request(
        `/api/v1/whatsapp-response-patterns/${this.deleteModal.id}`,
        {
          method: 'delete',
        }
      );

      if (err) {
        this.createAlert({
          status: 'error',
          data: this.getRequestErrorMessage(err),
        });
      } else {
        this.createAlert({
          status: 'success',
          data: 'Pola berhasil dihapus',
        });

        this.deleteModal.visible = false;

        this.loadPatterns();
      }

      this.loadingDelete = false;
    },
    onOpenCreateFormModal() {
      this.formModal.visible = true;
      this.formModal.id = null;
      this.formModal.form.pattern = null;
      this.formModal.form.defaultResponse = null;
      this.formModal.form.successResponse = null;
      this.formModal.form.failedResponse = null;
      this.formModal.form.media = null;
      this.formModal.form.withParams = false;
      this.formModal.form.handler = null;
      this.formModal.form.params = [];
      this.formModal.form.outputs = [];
      this.formModal.form.mediaUrl = null;
      this.formModal.form.editMedia = false;
    },
    onOpenEditFormModal(pattern) {
      this.formModal.visible = true;
      this.formModal.id = pattern.id;
      this.formModal.form.pattern = pattern.attributes.pattern;
      this.formModal.form.withParams = !!pattern.attributes.handler_class_id;
      this.formModal.form.media = null;
      this.formModal.form.defaultResponse = this.formModal.form.withParams
        ? null
        : pattern.attributes.default_response;
      this.formModal.form.successResponse = !this.formModal.form.withParams
        ? null
        : pattern.attributes.success_response;
      this.formModal.form.failedResponse = !this.formModal.form.withParams
        ? null
        : pattern.attributes.failed_response;
      this.formModal.form.handler = !this.formModal.form.withParams
        ? null
        : pattern.attributes.handler_class_id;
      this.formModal.form.params = !this.formModal.form.withParams
        ? []
        : pattern.attributes.params.split(' ');
      this.formModal.form.outputs = !this.formModal.form.withParams
        ? []
        : pattern.attributes.outputs.split(' ');
      this.formModal.form.editMedia = false;
      this.formModal.form.mediaUrl = pattern.attributes.media_url;
    },
    onOpenDeleteModal(pattern) {
      this.deleteModal.id = pattern.id;
      this.deleteModal.visible = true;
    },
    async onSaveForm() {
      const valid = this.validateMedia();

      if (valid) {
        this.loadingSavePattern = true;

        const [res, err] = await this.request(
          `${
            this.formModal.id
              ? `/api/v1/whatsapp-response-patterns/${this.formModal.id}`
              : '/api/v1/whatsapp-response-patterns'
          }`,
          {
            method: this.formModal.id ? 'patch' : 'post',
            data: {
              data: {
                type: 'whatsapp-response-patterns',
                ...(this.formModal.id ? { id: this.formModal.id } : {}),
                attributes: {
                  pattern: this.formModal.form.pattern,
                  default_response: this.formModal.form.withParams
                    ? null
                    : this.formModal.form.defaultResponse,
                  handler_class_id: this.formModal.form.withParams
                    ? this.formModal.form.handler
                    : null,
                  params: this.formModal.form.withParams
                    ? this.formModal.form.params.join(' ')
                    : null,
                  outputs: this.formModal.form.withParams
                    ? this.formModal.form.outputs.join(' ')
                    : null,
                  success_response: this.formModal.form.withParams
                    ? this.formModal.form.successResponse
                    : null,
                  failed_response: this.formModal.form.withParams
                    ? this.formModal.form.failedResponse
                    : null,
                },
              },
            },
          }
        );

        if (err) {
          this.createAlert({
            status: 'error',
            data: this.getRequestErrorMessage(err),
          });
        } else {
          if (this.formModal.form.media) {
            await this.uploadMedia(res.data.id, this.formModal.form.media);
          }

          this.createAlert({
            status: 'success',
            data: `Pola berhasil ${
              this.formModal.id ? 'diedit' : 'ditambahkan'
            }`,
          });

          this.formModal.visible = false;

          this.loadPatterns();
        }

        this.loadingSavePattern = false;
      }
    },
    onOpenDetailModal(pattern) {
      this.detailTemplate.pattern = pattern.attributes.pattern;
      this.detailTemplate.params = pattern.attributes.params;
      this.detailTemplate.outputs = pattern.attributes.outputs;
      this.detailTemplate.handler = pattern.attributes.handler_class_id;
      this.detailTemplate.defaultResponse = pattern.attributes.default_response;
      this.detailTemplate.successResponse = pattern.attributes.success_response;
      this.detailTemplate.failedResponse = pattern.attributes.failed_response;
      this.detailTemplate.hasMedia = pattern.attributes.has_media;
      this.detailTemplate.mediaMimeType = pattern.attributes.media_mime_type;
      this.detailTemplate.mediaSize = pattern.attributes.media_size;
      this.detailTemplate.mediaUrl = pattern.attributes.media_url;
      this.detailTemplate.visible = true;
    },
    async uploadMedia(id, file) {
      const data = new FormData();

      data.append('file', file);

      await this.request(
        `/api/v1/whatsapp-response-patterns/${id}/-actions/upload-media`,
        {
          method: 'post',
          data,
        }
      );
    },
    validateMedia() {
      if (!this.formModal.form.media) {
        return true;
      }

      const max = 1024 * 1024 * 16;

      if (this.formModal.form.media.size > max) {
        this.createAlert({
          status: 'error',
          data: 'Ukuran media melebihi batas',
        });

        return false;
      }

      return true;
    },
  },
  created() {
    this.loadHandlers();
    this.loadPatterns();
  },
};
</script>
